import Bowser from 'bowser';
import { getRecaptcha } from './recaptcha';
import { mount } from '../dom-lifecycle';

mount('[data-receipt-file-upload]', function () {
    const $container = $(this);
    const $input = $container.find('[data-ref=input]');
    const $dataPreview = $container.find('[data-ref=data-preview]');
    const $scannerModal = $container.find('[data-ref=scanner-modal]');
    const $scannerContainer = $container.find('[data-ref=scanner-container]');

    $input.on('change', async function () {
        $container.find('[name=receiptUuid]').remove();
        $container.find('.file-error').remove();

        const file = this.files[0];
        if (!file) {
            return;
        }
        const formData = new FormData();
        formData.set('file', file);
        //formData.set('g-recaptcha-response', await getRecaptcha());
        formData.set('_token', $(this).data('token'));
        formData.set('wsUuid', await getWebsocketUuid());
        openWebSocket(formData.get('wsUuid'));

        try {
            var data = await $.ajax({
                type: 'POST',
                url: $(this).data('url'),
                data: formData,
                processData: false,
                contentType: false,
            });
        } catch (xhr) {
            const errors = xhr.responseJSON?.errors;
            const defaultMessage = 'Wystąpił nieznany błąd, proszę spróbować jeszcze raz.';
            const message = errors ? Object.values(errors).flat().join('<br>') : defaultMessage;
            $(this).closest('.form-group').append(`<div class="invalid-feedback d-block file-error">${message}</div>`)
            return;
        }
        $container.append(`<input type="hidden" name="receiptUuid" value="${data.receiptUuid}">`);
        for (let name in data.billData) {
            $(`input[name="personal_data[${name}]"]`).val(data.billData[name]).trigger('input');
        }
    });

    function getWebsocketUuid() {
        return fetch($input.data('ws-uuid-url'))
            .then(response => response.json())
            .then(data => data.uuid)
            .catch(() => {});
    }

    function openWebSocket(uuid) {
        var ws = new WebSocket($input.data('ws-url'));
        ws.onmessage = data => { 
            $dataPreview.html($dataPreview.html() + data.data.replace('\n', '<br />'));
            $dataPreview.scrollTop($dataPreview[0].scrollHeight);
        };
        ws.onopen = () => ws.send(JSON.stringify({ uuid: uuid }));
    }

    $input.on('click', function (e) {
        if (['mobile', 'tablet'].includes(Bowser.parse(navigator.userAgent).platform.type)) {
            e.preventDefault();

            $scannerModal.modal('show');
        }
    });

    $scannerModal.on('show.bs.modal', function () {
        const scannerUrl = $input.data('scanner-url');

        $scannerContainer.append(
            `<iframe width="100%" height="auto" style="width: 100%; height: 100%; min-height: 90dvh;" src="${scannerUrl}" allow="camera; microphone"></iframe>`
        );
    });

    $scannerModal.on('hide.bs.modal', function () {
        if (window.innerWidth < 992) {
            $scannerContainer.find('iframe').remove();
        }
    });

    window.addEventListener('message', function(event) {
        let scannerData;

        try {
            scannerData = JSON.parse(event.data);
        } catch (e) {
            scannerData = null;
        }

        if (scannerData && scannerData?.name === 'scannerImage') {
            let file = dataURLtoFile(scannerData.data, 'receipt.png');
            let container = new DataTransfer();
            container.items.add(file);
            $input.prop('files', container.files).trigger('change');
            $scannerModal.modal('hide');
        }
    });
});

function dataURLtoFile(dataurl, filename) {
    var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);

    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
}